module.exports = __webpack_public_path__ + "img/zgpan.167f5459.png";